/**
 * close button functionality
 */
(() => {
  const infoBar = document.querySelector('.header-info');
  const closeBtn = document.querySelector('.header-info .close-btn');

  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      infoBar.classList.add('hide');
    });
  }
})();
